import React, { useEffect, useRef, useState } from 'react';
import search from '../Images/search.png';
import backBtn from '../Images/back.png';
import profile from '../Images/profile.png';
import add from '../Images/add.png';
import '../css/consultations.css';
import '../css/doctors.css';
import triangle from "../Images/triangle.png";
import copy from '../Images/copy_green.png';
import { Link, useNavigate } from 'react-router-dom';
import { Search, User } from 'lucide-react';

function Doctors() {
  const searchInputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [allDoctors, setAllDoctors] = useState([]);
  const [patients, setPatients] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [specialities, setSpecialities] = useState([]);
  const [doctorsSpecialities, setDoctorsSpecialities] = useState({});
  const [searchPat, setSearchPat] = useState([])
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  // const [doctorData]

  const handleSearchClick = () => {
    if (searchInputRef.current) {
      searchInputRef.current.focus();
      setIsFocused(true);
    }
  };

  const handleBlur = (e) => {
    if (e.relatedTarget && e.relatedTarget.closest('.allResults')) {
      return; // Prevent losing focus if clicking inside allResults
    }
    setIsFocused(false);
  };

  // Fetch specialties for each doctor
  const fetchDoctorSpeciality = async (doctorId) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/doctors-by-speciality/${doctorId}/`);
      const json = await response.json();
      console.log('json', json)
      if (response.ok) {
        setDoctorsSpecialities((prevState) => ({
          ...prevState,
          [doctorId]: json,
        }));
        // console.log('doctorsSpecialities',doctorsSpecialities)
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/doctor-user/`);
      const json = await response.json();
      if (response.ok) {
        setAllDoctors(json);
        // Fetch each doctor's specialties
        json.forEach((doctor) => fetchDoctorSpeciality(doctor.id));
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {

    const fetchData2 = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/patients-user/`);
        const json = await response.json();
        if (response.ok) {
          setPatients(json);
          setSearchPat((prev) => [
            ...(json.patients_with_doctor || []),
            ...(json.patients_without_doctor || [])
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    };
    const fetchData3 = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/specialities-options/`);
        const json = await response.json();
        if (response.ok) {
          setSpecialities(json);
        }
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
    fetchData2();
    fetchData3();
  }, []);

  const [selectedSpecialty, setSelectedSpecialty] = useState(null); // Track selected specialty

  // Handle selecting a specialty
  const handleSpecialtyClick = (specialtyName) => {
    console.log(specialtyName);
    if (selectedSpecialty === specialtyName) {
      // If the same specialty is clicked, reset the filter
      setSelectedSpecialty(null);
    } else {
      setSelectedSpecialty(specialtyName); // Set the selected specialty
    }
  };

  // // Filter doctors based on selected specialty
  // const filteredDoctors = selectedSpecialty
  //   ? allDoctors.filter((doctor) =>
  //     doctor.specialities.some((spec) => spec.name === selectedSpecialty)
  //   )
  //   : allDoctors; 

  const filteredDoctors = selectedSpecialty
  ? allDoctors.filter((doctor) =>
      doctor.specialities.map((spec) => spec.name).includes(selectedSpecialty)
    )
  : allDoctors;


  useEffect(() => {
    if (searchTerm) {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const filteredPatients = searchPat.filter((patient) =>
        patient?.full_name?.toLowerCase().includes(lowercasedSearchTerm) ||
        patient.id.toString().includes(lowercasedSearchTerm)
      );
      const filteredDoctors = allDoctors.filter((doctor) =>
        doctor?.username?.toLowerCase().includes(lowercasedSearchTerm)
      );
      setFilteredResults([...filteredPatients, ...filteredDoctors]);
    } else {
      setFilteredResults([]);
    }
  }, [searchTerm, searchPat, allDoctors]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const [ccIndex, setCcIndex] = useState(0);

  const handleCcLeftSlide = () => {
    if (ccIndex > 0) {
      setCcIndex(ccIndex - 1);
    }
  };

  const handleCcRightSlide = () => {
    if (ccIndex < 2) {
      setCcIndex(ccIndex + 1);
    }
  };

  const groupSpecialities = (specialities, size) => {
    const grouped = [];
    for (let i = 0; i < specialities.length; i += size) {
      grouped.push(specialities.slice(i, i + size));
    }
    return grouped;
  };

  const [linkPat, setLinkPat] = useState([])
  const [lp, setLp] = useState(false)
  const handleLinkPat = async (id) => {
    // e.preventDefault();
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/doctor-user/`);
      const json = await response.json();
      if (response.ok) {
        // Find the doctor with the matching ID
        const doctor = json.find((doc) => doc.id === id);
        if (doctor) {
          console.log('doctor', doctor)
          setLinkPat(doctor); // Set the state to the found doctor
          setLp(true)
        }
      }
    } catch (error) {
      console.error('Error fetching doctor:', error);
    }
  };

  const linkToCopy = `${process.env.REACT_APP_BASE_URL}/api/send-doctor-invitation/`;

  const handleInvite = async () => {
    try {
      await navigator.clipboard.writeText(linkToCopy);
      alert('Link copied to clipboard!');
    } catch (error) {
      console.error('Failed to copy:', error);
    }
  };

  const handleAddDoctor = () => {
    setShowModal(true);
  };

  // Update the initial form state
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: 'demo@123',
    password2: 'demo@123',
    full_name: '',
    birthdate: '',
    gender: '',
    specialities: [],
    phone_number: '',
    image: null // Will store the actual file object
  });

  // Update handleInputChange to handle file inputs
  const handleInputChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      setFormData(prev => ({
        ...prev,
        [name]: files[0] // Store the file object
      }));
    } else if (type === 'checkbox') {
      const updatedSpecialities = checked
        ? [...formData.specialities, value]
        : formData.specialities.filter(id => id !== value);

      setFormData(prev => ({
        ...prev,
        specialities: updatedSpecialities
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  // Update submit handler to use FormData
  const handleSubmit = async (e) => {
    e.preventDefault();

    const submitFormData = new FormData();

    // Append all form fields to FormData
    Object.keys(formData).forEach(key => {
      if (key === 'specialities') {
        // Append each specialty ID separately
        formData.specialities.forEach(specialtyId => {
          submitFormData.append('specialities', specialtyId);
        });
      } else if (key === 'image' && formData[key]) {
        submitFormData.append('image', formData[key]);
      } else {
        submitFormData.append(key, formData[key]);
      }
    });

    // Add default values
    submitFormData.append('weight', '75.5');
    submitFormData.append('weight_unit', 'KG');
    submitFormData.append('height', '180');

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/doctor-register/`, {
        method: 'POST',
        body: submitFormData // Send FormData instead of JSON
      });

      if (response.ok) {
        alert('Doctor added successfully!');
        setShowModal(false);
        fetchData()
        // Optionally refresh the doctors list here
      } else {
        const errorData = await response.json();
        alert('Failed to add doctor: ' + JSON.stringify(errorData));
      }
    } catch (error) {
      console.error('Error adding doctor:', error);
      alert('Error adding doctor. Please try again.');
    }
  };

  useEffect(() =>{
    console.log(filteredDoctors)
  },[filteredDoctors])

  return (
    <div className='conMain docMain'>
      {lp && <div className='aps'>
        <div className='allPat'>
          <h2>Linked Patients to this doctor</h2>
          {linkPat.patients.map((lp, index) => (
            <p> <Link to={`/dash2/${lp.id}`} key={index}>{lp.full_name}</Link></p>


          ))}
          {linkPat?.patients?.length === 0 && <p>None</p>}
          <div onClick={() => setLp(false)} className='close'>X</div>
        </div></div>}
      {isFocused && <div className="blur"></div>}
      <div className="sna">
        <div className="searchnRes">
          <div className="cdpNavbar" onClick={handleSearchClick}>
            <div className="cdpn">
              {/* <button><img src={backBtn} alt="" /></button> */}
              <div className="cdpSearch">
                <input
                  type="text"
                  placeholder='Search Patients & Doctors'
                  ref={searchInputRef}
                  onBlur={handleBlur}
                  onFocus={() => setIsFocused(true)}
                  value={searchTerm}
                  onChange={handleSearchChange}
                />
                <div className="">
                  <Search className="w-5 h-5 m-2 text-pink-500" />
                </div>
              </div>
            </div>
            <img src={profile} alt="profile" />
          </div>

          {isFocused && searchTerm && (
            <div
              className="allResults"
              tabIndex={-1}
              onMouseDown={(e) => e.preventDefault()}
            >
              <p>Search Results</p>
              {filteredResults.length > 0 ? (
                filteredResults.map((result, index) => (
                  <span
                    onClick={() => { result.role === "PATIENT" ? window.location.href = `/dash2/${result.id}` : window.location.href = `/doctor/${result.id}` }}
                    key={index}
                    className="resultItem"
                  >
                    <p>{result.full_name || result.username}</p>
                  </span>
                ))
              ) : (
                <p>No results found</p>
              )}
            </div>
          )}
        </div>
        <div className="dSpec">
          <div className="dsTop cdpnTop">
            <h1>Speciality</h1>
            {/* <button>
              <img src={add} alt="add" />
              <p>Add Filter</p>
            </button> */}
          </div>
          <div className="dsSlide d2lc">
            <div className="sliderMain">
              <div className="sm">
                <div className="sliderBtns">
                  <button className="left" onClick={handleCcLeftSlide}>
                    <img src={backBtn} alt="triangle" />
                  </button>
                  <button className="right" onClick={handleCcRightSlide}>
                    <img src={backBtn} alt="triangle" />
                  </button>
                </div>
                <div className="sliderWindow">
                  <div
                    className="slider"
                    style={{
                      transform: `translateX(-${(ccIndex * 100) / 3}%)`,
                    }}
                  >
                    {groupSpecialities(specialities, 5).map((group, index) => (
                      <div className="slide" key={index}>
                        {group.map((speciality) => (
                          <p key={speciality.id} style={{ cursor: "pointer", border: selectedSpecialty === speciality.name ? "1px solid #FE4A95" : "1px solid transparent" }} onClick={(e) => handleSpecialtyClick(speciality.name)}>{speciality.name}</p>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cdpNewOn allCon">
          <div className="cdpnTop">
            <div className="headFit">
              <h1>Doctors</h1>
              <button className="addDoctorBtn" onClick={handleAddDoctor}>
                <img src={add} alt="add" />
                <p>Add Doctor</p>
              </button>
            </div>
          </div>

          {showModal && (
            <div className="modal-overlay">
              <div className="modal-content">
                <h2>Add New Doctor</h2>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <label>Username:</label>
                    <input
                      type="text"
                      name="username"
                      value={formData.username}
                      onChange={handleInputChange}
                      placeholder="Enter username"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Profile Image:</label>
                    <input
                      type="file"
                      name="image"
                      accept="image/*"
                      onChange={handleInputChange}
                    />
                  </div>

                  <div className="form-group">
                    <label>Email:</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      placeholder="Enter email"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Phone Number:</label>
                    <input
                      type="tel"
                      name="phone_number"
                      value={formData.phone_number}
                      onChange={handleInputChange}
                      placeholder="Enter phone number"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Full Name:</label>
                    <input
                      type="text"
                      name="full_name"
                      value={formData.full_name}
                      onChange={handleInputChange}
                      placeholder="Enter doctor's full name"
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Birth Date:</label>
                    <input
                      type="date"
                      name="birthdate"
                      value={formData.birthdate}
                      onChange={handleInputChange}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label>Gender:</label>
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Select gender</option>
                      <option value="MALE">Male</option>
                      <option value="FEMALE">Female</option>
                      <option value="OTHER">Other</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Specialities:</label>
                    <div className="specialties-checkbox-group">
                      {specialities.map(spec => (
                        <label key={spec.id} className="specialty-checkbox">
                          <input
                            type="checkbox"
                            name="specialities"
                            value={spec.id}
                            checked={formData.specialities.includes(spec.id.toString())}
                            onChange={handleInputChange}
                          />
                          {spec.name}
                        </label>
                      ))}
                    </div>
                  </div>

                  <div className="modal-buttons">
                    <button type="submit">Add Doctor</button>
                    <button type="button" onClick={() => setShowModal(false)}>Cancel</button>
                  </div>
                </form>
                <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
              </div>
            </div>
          )}

          {!selectedSpecialty && allDoctors.map((ad, index) => (
            <div className="cdpno" key={index}>
              <div className="cdpProf">
                <div className="pinkBox">
                  <div className="profImg">
                    {ad.image ? <img src={`${process.env.REACT_APP_BASE_URL}${ad.image}`} alt={`${ad.username} profile`} /> : <User className='w-12 h-12 bg-gray-200 rounded-full p-2' />}
                    <div className="pDesc">
                      <p>{ad.username}</p>
                      <p>{ad.phone_number}</p>
                    </div>
                  </div>
                  <button onClick={() => navigate(`/doctor/${ad.id}`)}>View Profile</button>
                </div>
                <div className="pinkBox">
                  <p>Speciality(ies)</p>
                  <div className="sps">
                    {/* {doctorsSpecialities[ad.id]?.map((ds, index) => (
                      <div key={index}>{
                        ds.specialities.map((d, index)=>(
                          <p style={{fontWeight: 'bold'}} key={index}>{d.name}</p>
                        ))
                      }</div>
                    ))} */}

                    {/* {console.log('alldoc', allDoctors)} */}
                    {console.log('ad', ad)}
                    {ad.specialities.map(spec => <li>{spec.name}</li>)}
                  </div>
                </div>
                <div className="pinkBox pb">
                  <p>Linked Patients</p>
                  <button onClick={() => handleLinkPat(ad.id)}>View All</button>
                </div>
              </div>
            </div>
          ))}
          {selectedSpecialty && filteredDoctors.map((ad, index) => (
            <div className="cdpno" key={index}>
              <div className="cdpProf">
                <div className="pinkBox">
                  <div className="profImg">
                    <img src={profile} alt="profile" />
                    <div className="pDesc">
                      <p>{ad.username}</p>
                      <p>{ad.phone_number}</p>
                    </div>
                  </div>
                  <button onClick={() => navigate(`/doctor/${ad.id}`)}>View Profile</button>
                </div>
                <div className="pinkBox">
                  <p>Speciality(ies)</p>
                  <div className="sps">
                    <div key={index}>{
                      ad.specialities.map((d, index) => (
                        <p style={{ fontWeight: 'bold' }} key={index}>{d.name}</p>
                      ))
                    }</div>
                  </div>
                </div>
                <div className="pinkBox pb">
                  <p>Linked Patients</p>
                  <button onClick={() => handleLinkPat(ad.id)}>View All</button>
                </div>
              </div>
            </div>
          ))}
          {!allDoctors || filteredDoctors == "" && <b>No doctors found</b>}
        </div>
      </div>
    </div>
  );
}

export default Doctors;
